<div class="page-container">
    @if (wizardSteps) {
        <div class="wizard">
            <div class="logo">
                <img src="assets/img/logo.png" [alt]="'general.brandLogo' | translate" />
            </div>
            <div class="backlink">
                <span class="material-icons">arrow_back</span>
                <a [href]="backLinkUrl">onego.io</a>
            </div>
            <div class="dialog">
                <div class="page-image">
                    <img [src]="'assets/img/' + step.image" [alt]="'steps.titles.' + step.id | translate" />
                    @if (step.id === 'tenant-invite') {
                        <span class="page-image-tenant">{{ formData.tenantName }}</span>
                    }
                </div>
                <div class="steps">
                    <h1 class="steps-title">
                        {{ 'steps.titles.' + step.id | translate }}
                    </h1>
                </div>
                <div class="form">
                    <app-wizard-step-create-account />
                    <app-wizard-step-login />
                    <app-wizard-step-profile />
                    <app-wizard-step-tenant-invite />
                    <app-wizard-step-tenant-invite-success />
                    <app-wizard-step-logged-in />
                    <app-wizard-step-update-success />
                </div>
                <div class="controls">
                    @if (!stepComponent?.nextPageLink) {
                        <button
                            type="button"
                            class="btn color-secondary"
                            (click)="nextStep()"
                            [disabled]="nextDisabled"
                        >
                            @if (!nextDisabled) {
                                <span @fade>
                                    {{ 'buttons.' + stepComponent?.nextButtonLabel | translate }}
                                </span>
                            }
                            @if (nextDisabled) {
                                <ogs-spinner @fade></ogs-spinner>
                            }
                        </button>
                    }
                    @if (stepComponent?.nextPageLink) {
                        <a [href]="stepComponent?.nextPageLink" target="_blank" class="btn color-secondary">
                            {{ 'buttons.' + stepComponent?.nextButtonLabel | translate }}
                        </a>
                    }
                </div>
            </div>
        </div>
    }
</div>
